import {
  httpRequest,
  querystringBuilderByObject
} from '@common/util/api-common.util';

export default class ArquivamentoApi {
  static getUsuario () {
    return httpRequest('segusu/histologia').then(json => json.data);
  }

  static getItensRelatorio (
    tipo,
    filtroTipoValue,
    filtroValue,
    dataInicio,
    dataFim
  ) {
    const obj = filtroTipoValue.includes('dt')
      ? { filtroTipoValue, dataInicio, dataFim }
      : { filtroTipoValue: filtroTipoValue, filtroValue };

    const query = querystringBuilderByObject(obj);

    switch (tipo) {
      case 1:
        return httpRequest(`auditoria/ArquivamentoRequisicao/${query}`).then(
          (json) => json.data
        );
      case 2:
        return httpRequest(`arquivamento/relatorio/${query}`).then(
          (json) => json.data
        );
      case 3:
        return httpRequest(`RequisicaoBlocosLaminas/relatorio/${query}`).then(
          (json) => json.data
        );

      default:
        break;
    }
 }

  //#region ARQUIVAMENTO DE MATERIAL

  static getArquivamento (tecnicoId, dataInicio, dataFim, nrExame) {
    tecnicoId = tecnicoId ? tecnicoId : null;
    const obj = { tecnicoId, dataInicio, dataFim, nrExame };
    const query = querystringBuilderByObject(obj);

    return httpRequest(`arquivamento${query}`).then(json => json.data);
  }

  static updateArquivamento (item) {
    const itemArquivamento = {
      ArquivamentoId: item.laudoArquivosId,
      Localizacao: item.localizacaoArquivamento,
      Status: item.status
    };
    return httpRequest(
      'arquivamento/atualizarstatus',
      'PATCH',
      itemArquivamento
    ).then(json => json.data);
  }

  static deleteArquivamento (id) {
    return httpRequest(`arquivamento/${id}`, 'DELETE').then(json => json.data);
  }

  static getArquivamentoManual (tipo, dataInicio, dataFim, nrExame) {
    const obj = { tipo, dataInicio, dataFim, nrExame };
    const query = querystringBuilderByObject(obj);

    return httpRequest(`arquivamento/arquivamentomanual${query}`).then(
      json => json.data
    );
  }

  static postArquivamento (item) {
    const itemArquivamento = {
      Itens: item.itens,
      Localizacao: item.localizacao,
      Motivo: item.motivo
    };
    return httpRequest('arquivamento', 'POST', itemArquivamento).then(
      json => json.data
    );
  }
  //#endregion

  //#region REQUISIÇÃO DE MATERIAL
  static getRequisicao (tecnicoId, dataInicio, dataFim, nrExame) {
    tecnicoId = tecnicoId ? tecnicoId : null;
    const obj = { tecnicoId, dataInicio, dataFim, nrExame };
    const query = querystringBuilderByObject(obj);

    return httpRequest(`RequisicaoBlocosLaminas${query}`).then(
      json => json.data
    );
  }

  static getItemsRequisicaoPorIdentificacao (itens) {
    return httpRequest(
      `RequisicaoBlocosLaminas/itens-requisitados-anteriormente`,
      'POST',
      itens
    ).then(json => json.data);
  }

  static postRequisicao (item) {
    const itemRequisicao = {
      ...item,
      idRequisitante: item.idRequisitante ? item.idRequisitante.value : 0,
      tipoEntrega: item.tipoEntrega.value
    };
    return httpRequest('RequisicaoBlocosLaminas', 'POST', itemRequisicao).then(
      json => json.data
    );
  }

  static getExameRequisicao (nrExame) {
    nrExame = encodeURIComponent(nrExame);
    return httpRequest(`arquivamento/nr-exame/${nrExame}`).then(
      json => json.data
    );
  }

  static updateRequisicao (item) {
    const itemrequisicao = {
      IdRequisicao: item.idRequisicao,
      Status: item.status
    };
    return httpRequest(
      'RequisicaoBlocosLaminas/atualizarstatus',
      'PATCH',
      itemrequisicao
    ).then(json => json.data);
  }

  static deleteRequisicao (idRequisicao, justificativa) {
    const item = {
      idRequisicao,
      justificativa
    };
    return httpRequest(`RequisicaoBlocosLaminas`, 'DELETE', item).then(
      json => json.data
    );
  }
  //#endregion

  //#region RELATÓRIOS

  //#endregion
}



// WEBPACK FOOTER //
// ./src/pages/arquivamento/arquivamento.api.js